import { useSelector } from "react-redux";

import {
  AnalyzeCampaignRequestBodyType,
  AnalyzeResourceResponseBodyType,
  DatasetId,
} from "@intelligems/ig-types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { IAppState } from "../../store/types/store";
import { api } from "../api";

const fetchAllPersonalizationOverviewData = async (
  data: AnalyzeCampaignRequestBodyType
) => {
  const resp = await api.post<
    AnalyzeResourceResponseBodyType,
    AnalyzeCampaignRequestBodyType
  >(`/v2/analytics/analyze-resource`, data);

  return resp.data;
};

export const useAllPersonalizationOverviewData = (
  datasetId: DatasetId
): UseQueryResult<AnalyzeResourceResponseBodyType, Error> => {
  const dashboardFilters = useSelector(
    (state: IAppState) => state.dashboardFilters
  );
  const data: AnalyzeCampaignRequestBodyType = {
    ...dashboardFilters,
    experienceId: null,
    resourceType: "campaigns",
    datasetId: datasetId,
    startTime: dashboardFilters.startTime ?? null,
    endTime: dashboardFilters.endTime ?? null,
  };
  return useQuery<AnalyzeResourceResponseBodyType, Error>({
    queryKey: ["allPersonalizationData"],
    queryFn: async () => fetchAllPersonalizationOverviewData(data),
  });
};
